import React, { forwardRef } from 'react';

const withRef = Component => forwardRef((props, ref) => (
  <Component forwardedRef={ref} {...props} />
));

export default withRef;
